class FaqAccordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const toggle = '.js-faq-accordion';
    $(toggle).on('click',function(){
      $(this).toggleClass('is-active');
      $(this).next().slideToggle();
    })
  }
}